<app-widget-container [widgetTitle]="widgetTitle" [widgetIcon]="widgetIcon">

  <div class="toc-header flex-container">
    <div class="flex-item-60">
      <mat-form-field class="toc-search">
        <mat-label>Search layers</mat-label>
        <label>
          <input type="text" (click)="gatherTags()" (keydown)="filterEnterKey($event)" matInput placeholder="Filter by name and tags" [(ngModel)]="tagFilter" [matAutocomplete]="tocSearch">
        </label>
        <mat-autocomplete #tocSearch="matAutocomplete" [panelWidth]="'auto'">
          <mat-option *ngFor="let tag of tagList | tagFilterBy: tagFilter; trackBy: trackBy" [value]="tag">{{tag}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button mat-icon-button color="primary" type="submit" (click)="filterToC()" matTooltip="Search"><mat-icon>search</mat-icon></button>
      <button *ngIf="tagFilter.length > 0" mat-stroked-button (click)="clearSearch()" matTooltip="Clear Search" >Clear Search</button>
      <!-- <button *ngIf="tagFilter.length > 0" mat-icon-button color="primary" type="submit" (click)="clearSearch()" matTooltip="Clear"><mat-icon>clear</mat-icon></button> -->
    </div>
    <div class="theme-button">
      <button *ngIf="changelog" mat-raised-button style="margin-right:5px" type="button" color="primary" matTooltip="What's new" (click)="changelogClick()">
        <mat-icon>fiber_new</mat-icon>
      </button>
      <button #themeMenuTrigger [matMenuTriggerFor]="themeMenu" color="primary" type="button" [ngClass]="{hidden: hideThemeChangeButton, themeButton: true}" mat-raised-button matTooltip="Single topic maps">
        <span class="icon esri-icon-media"></span>
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #themeMenu="matMenu">
        <button mat-menu-item *ngFor="let theme of themeList" (click)="themeClick(theme)" >{{theme}}</button>
        <!-- <button mat-menu-item *ngFor="let theme of themeList" (click)="themeClick(theme)" [disabled]="theme === currentTheme">{{theme}}</button> -->
      </mat-menu>
    </div>
  </div>

  <mat-divider class="divider"></mat-divider>
<!------------------------------------------------------------------ -->
  <div class="toc-contents">
      <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="toc-tree" [trackBy]="trackBy">
        <mat-tree-node *matTreeNodeDef="let node"
          [matTooltip]="'Layer Unavailable.'" [matTooltipDisabled]="node.layerAvailable">
          <div class="mat-tree-node" [ngClass]="{'ui-layer-list-out-of-scale': !isLayerInScale(node),
          'ui-layer-list-error': !node.layerAvailable}" matTreeNodeToggle >
            <mat-checkbox id="{{node.id}}_childCkBox"  class="toc-margin" color="warn" [(ngModel)]="node.isChecked"
                          (change)="layerCkBoxClicked($event, node)" (click)="$event.stopPropagation()"
                          [aria-label]="node.name"  [disabled]="!node.layerAvailable" >
            </mat-checkbox>

             {{node.name}}
            <app-dropdown *ngIf="node.download || node.trans" [node]="node"></app-dropdown>
          </div>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
          <div>
            <div class="mat-tree-node tree-parent" matTreeNodeToggle (click)="showDisclaimer(node)">
              <mat-icon class="mat-icon-play-arrow" [ngClass]="nestedTreeControl.isExpanded(node) ? 'expand-more' : 'chevron_right'">
                chevron_right
              </mat-icon>
              <div *ngIf = "node.hasCheckBox">
                <mat-checkbox  id="{{node.id}}_parentCkBox" class="toc-margin"  color="warn"  [(ngModel)]="node.isChecked"
                              (change)="parentCkBoxClicked($event, node)"
                              (click)="$event.stopPropagation()" [aria-label]="node.id">
                               <!-- [disabled]="!node.layerAvailable" (click)="$event.stopPropagation()" [aria-label]="node.id"> -->
                </mat-checkbox>
              </div>
              <span> {{node.id}}</span>
              <app-dropdown *ngIf="node.download || node.trans" (click)="$event.stopPropagation();" [node]="node"></app-dropdown>
            </div>
            <div [class.toc-tree-invisible]="!nestedTreeControl.isExpanded(node)" class="toc-indent">
              <ng-container matTreeNodeOutlet *ngIf="nestedTreeControl.isExpanded(node)"></ng-container>
            </div>
          </div>
        </mat-nested-tree-node>
      </mat-tree>
    </div>

    <!--basemaps------------------------------------------------------------ -->
    <div>
      <mat-tree [dataSource]="nestedBasemapSource" [treeControl]="nestedBasemapControl" class="toc-tree" [trackBy]="trackBy">
        <mat-tree-node *matTreeNodeDef="let node">
          <div class="mat-tree-node" matTreeNodeToggle>
            <mat-checkbox id="{{node.id}}_childCkBox"  class="toc-margin" color="warn" [(ngModel)]="node.isChecked"
                          (change)="basemapClicked($event, node)" (click)="$event.stopPropagation()"
                          [aria-label]="node.name" >
            </mat-checkbox>

            {{node.name}}
            <app-dropdown *ngIf="node.trans" (click)="$event.stopPropagation();" [node]="node"></app-dropdown>
          </div>
        </mat-tree-node>

        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
          <div>
            <div class="mat-tree-node tree-parent" matTreeNodeToggle >
              <mat-icon class="mat-icon-play-arrow" [ngClass]="nestedBasemapControl.isExpanded(node) ? 'expand-more' : 'chevron_right'">
                chevron_right
              </mat-icon>
              <div *ngIf = "node.hasCheckBox">
                <mat-checkbox  id="{{node.id}}_parentCkBox" class="toc-margin"  color="warn"  [(ngModel)]="node.isChecked"
                               (click)="$event.stopPropagation()" [aria-label]="node.id">
                </mat-checkbox>
              </div>
              <span> {{node.id}}</span>
              <app-dropdown *ngIf="node.trans" (click)="$event.stopPropagation();" [node]="node"></app-dropdown>
            </div>
            <div [class.toc-tree-invisible]="!nestedBasemapControl.isExpanded(node)" class="toc-indent">
              <ng-container matTreeNodeOutlet *ngIf="nestedBasemapControl.isExpanded(node)"></ng-container>
            </div>
          </div>
        </mat-nested-tree-node>
      </mat-tree>

    </div>

<!--Help documents------------------------------------------------------------ -->
<br>
<div *ngFor = "let item of themeHelpInfo">
  <a [attr.href]="item.url" target="_blank">
   {{item.name}}
  </a>
</div>

<!------------------------------------------------------------------ -->
</app-widget-container>

